// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2tVj5","col":"styles_col__2z6Gy","fulfillmentStatus":"styles_fulfillmentStatus__mq8Kh","emailCol":"styles_emailCol__2dyPn"};